export const environment = {
  API_URL: "https://api.mynvoice.ensolvers.com",
  GOOGLE_RECAPTCHA_URL: "6LfVrosaAAAAAImHhaWmnHjQKBoLupfHuGuO36g7",
};
